'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageFAQNavigation = function () {
  function PageFAQNavigation() {
    var _this = this;

    (0, _classCallCheck3.default)(this, PageFAQNavigation);

    this.itemsArray = [];

    this.sectionExternalEls = (0, _functional.getElements)('[data-external-el="faq-navigation.section"]');
    this.itemsEl = (0, _functional.getElement)('[data-el="faq-navigation.items"]');

    this.sectionExternalEls.forEach(function (section) {
      _this.buildItems(section.dataset.faqNavigationTitle);
    });

    this.buttonEls.forEach(function (button) {
      button.addEventListener('click', _this.onClick.bind(_this));
    });
  }

  (0, _createClass3.default)(PageFAQNavigation, [{
    key: 'buildItems',
    value: function buildItems(link) {
      if (!this.itemsArray.includes(link.toLowerCase())) {
        this.itemsArray.push(link.toLowerCase());

        var item = document.createElement('li');
        item.classList.add('faq-Navigation_Item');

        var button = document.createElement('button');
        button.classList.add('faq-Navigation_Link');
        button.setAttribute('data-el', 'faq-navigation.button');
        button.appendChild(document.createTextNode(link));

        item.appendChild(button);

        this.itemsEl.appendChild(item);

        this.buttonEls = (0, _functional.getElements)('[data-el="faq-navigation.button"]');

        this.observeItems();
      }
    }
  }, {
    key: 'observeItems',
    value: function observeItems() {
      var observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      };

      function observerCallback(entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var navItem = Array.from(document.querySelectorAll('[data-el="faq-navigation.button"]')).find(function (el) {
              return el.textContent === entry.target.dataset.faqNavigationTitle;
            });

            navItem.classList.add('faq-Navigation_Link-active');
            document.querySelectorAll('[data-el="faq-navigation.button"]').forEach(function (item) {
              if (item !== navItem) {
                item.classList.remove('faq-Navigation_Link-active');
              }
            });
          }
        });
      }

      // eslint-disable-next-line compat/compat
      var observer = new IntersectionObserver(observerCallback, observerOptions);

      this.sectionExternalEls.forEach(function (sec) {
        return observer.observe(sec);
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      var target = (0, _functional.getElement)('[data-faq-navigation-title="' + e.target.firstChild.nodeValue + '"]');
      var documentTop = document.documentElement.scrollTop || document.body.scrollTop;
      var elementTop = (0, _functional.getOffsetTop)(target);
      var offset = elementTop < documentTop ? 82 : 0;

      window.scrollTo({
        top: elementTop - offset,
        left: 0,
        behavior: 'smooth'
      });
    }
  }]);
  return PageFAQNavigation;
}();

exports.default = PageFAQNavigation;